import { hasSaves } from '../dialogs/SaveLoadDialog';

/**
 * Title screen — shown on launch before anything else.
 * New Game, Load Game (if saves exist).
 */
export async function showTitleScreen(
  parent: HTMLElement,
  onNewGame: () => void,
  onLoadGame: () => void,
): Promise<void> {
  const overlay = document.createElement('div');
  overlay.className = 'game-ui';
  overlay.style.cssText = 'position:fixed;inset:0;background:var(--color-bg-primary);z-index:400;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:24px;';

  const title = document.createElement('h1');
  title.textContent = 'Office Tycoon';
  title.style.cssText = 'font-size:40px;color:var(--color-accent);font-family:var(--font-pixel);letter-spacing:2px;margin:0;';
  overlay.appendChild(title);

  const subtitle = document.createElement('div');
  subtitle.textContent = 'Build Your Studio Empire';
  subtitle.style.cssText = 'font-size:14px;color:var(--color-text-muted);margin-top:-12px;letter-spacing:4px;';
  overlay.appendChild(subtitle);

  const btnContainer = document.createElement('div');
  btnContainer.style.cssText = 'display:flex;flex-direction:column;gap:12px;min-width:200px;margin-top:24px;';

  const makeBtn = (label: string, style: string, onClick: () => void) => {
    const btn = document.createElement('button');
    btn.className = `btn btn--${style}`;
    btn.textContent = label;
    btn.style.cssText = 'padding:12px 24px;font-size:16px;width:100%;';
    btn.addEventListener('click', () => {
      overlay.remove();
      onClick();
    });
    return btn;
  };

  btnContainer.appendChild(makeBtn('New Game', 'primary', onNewGame));

  // Only show Load if saves exist
  const savesExist = await hasSaves();
  if (savesExist) {
    btnContainer.appendChild(makeBtn('Load Game', 'success', onLoadGame));
  }

  overlay.appendChild(btnContainer);

  const version = document.createElement('div');
  version.textContent = 'v0.3';
  version.style.cssText = 'position:absolute;bottom:16px;right:16px;font-size:10px;color:var(--color-text-muted);';
  overlay.appendChild(version);

  parent.appendChild(overlay);
}
